import { callGet, callPost } from '../../services/axios'
import { toast } from '../../components/CommonComponents/ToastComponent/toast'

import { doLoggedInWithDomain } from './auth'

import {
  DO_CREATE_DOMAIN_START,
  DO_CREATE_DOMAIN_SUCCESS,
  DO_CREATE_DOMAIN_FAIL,
  DO_UPDATE_DOMAIN_START,
  DO_UPDATE_DOMAIN_SUCCESS,
  DO_UPDATE_DOMAIN_FAIL,
  DO_JOIN_OTHER_DOMAIN_START,
  DO_JOIN_OTHER_DOMAIN_SUCCESS,
  DO_JOIN_OTHER_DOMAIN_FAIL,
  DO_APPROVE_DOMAIN_REQUEST_START,
  DO_APPROVE_DOMAIN_REQUEST_SUCCESS,
  DO_APPROVE_DOMAIN_REQUEST_FAIL,
  DO_GET_DOMAIN_REQUESTORS_START,
  DO_GET_DOMAIN_REQUESTORS_SUCCESS,
  DO_GET_DOMAIN_REQUESTORS_FAIL,
  DO_GET_DOMAINS_BY_USER_ID_START,
  DO_GET_DOMAINS_BY_USER_ID_SUCCESS,
  DO_GET_DOMAINS_BY_USER_ID_FAIL,
  DO_GET_OTHER_DOMAINS_BY_USER_ID_START,
  DO_GET_OTHER_DOMAINS_BY_USER_ID_SUCCESS,
  DO_GET_OTHER_DOMAINS_BY_USER_ID_FAIL,
  DO_START_USER_DOMAIN_START,
  DO_START_USER_DOMAIN_SUCCESS,
  DO_START_USER_DOMAIN_FAIL,
  DO_SET_DOMAIN_INFO_MANUALLY,
  DO_REMOVE_DOMAIN_INFO,
  DO_INVITE_USER_TO_DOMAIN_START,
  DO_INVITE_USER_TO_DOMAIN_SUCCESS,
  DO_INVITE_USER_TO_DOMAIN_FAIL,
  DO_GET_JOINED_DOMAINS_BY_USER_ID_START,
  DO_GET_JOINED_DOMAINS_BY_USER_ID_SUCCESS,
  DO_GET_JOINED_DOMAINS_BY_USER_ID_FAIL,
} from '../actionTypes/domain'

export const doCreateDomain = ({
  domainName,
  companyName,
  address1,
  address2,
  city,
  state,
  zip,
  country,
  url,
  phone,
  industry,
  companySize,
}) => (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user

  dispatch({
    type: DO_CREATE_DOMAIN_START
  })

  return callPost(`/api/domain/create`, {
    domainName,
    companyName,
    address1,
    address2,
    city,
    state,
    zip,
    country,
    url,
    phone,
    industry,
    companySize,
    userId: id,
  }, token).then(res => {
    dispatch({
      type: DO_CREATE_DOMAIN_SUCCESS,
      data: res['data']
    })
    toast.show({
      title: 'Success',
      description: 'Domain is created successfully!',
    })
  }).catch(err => {
    dispatch({
      type: DO_CREATE_DOMAIN_FAIL
    })
    toast.show({
      title: 'Warning',
      description: 'Failed to create domain!',
    })
    return Promise.reject(err)
  })
}

export const doUpdateDomain = ({
  domainId,
  userRoleId,
  domainName,
  companyName,
  address1,
  address2,
  city,
  state,
  zip,
  country,
  url,
  phone,
  industry,
  companySize,
}) => (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user
  dispatch({
    type: DO_UPDATE_DOMAIN_START
  })

  return callPost(`/api/domain/updateDomainInfo`, {
    userId: id,
    domainId: domainId,
    userRoleId: userRoleId,
    domainName,
    companyName,
    address1,
    address2,
    city,
    state,
    zip,
    country,
    url,
    phone,
    industry,
    companySize,
  }, token).then(res => {
    dispatch({
      type: DO_UPDATE_DOMAIN_SUCCESS,
      data: {
        domainId: domainId,
        domainName: domainName,
        companyName: companyName,
        address1: address1,
        address2: address2,
        city: city,
        state: state,
        zip: zip,
        country: country,
        url: url,
        phone: phone,
        industry: industry,
        companySize: companySize,
      }
    })
    toast.show({
      title: 'Success',
      description: 'Domain updated successfully!'
    })
  }).catch(err => {
    dispatch({
      type: DO_UPDATE_DOMAIN_FAIL,
    })
    toast.show({
      title: 'Warning',
      description: 'Failed to update domain!',
    })
  })
}

export const doJoinOtherDomain = ({ domainId }) => (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user

  dispatch({
    type: DO_JOIN_OTHER_DOMAIN_START
  })

  return callPost(`/api/domain/joinOtherDomain`, {
    userId: id,
    domainId: domainId,
  }, token).then(res => {
    dispatch({
      type: DO_JOIN_OTHER_DOMAIN_SUCCESS,
      data: res['data']
    })
    toast.show({
      title: 'Success',
      description: 'Sent request to join domain successfully!',
    })
  }).catch(err => {
    dispatch({
      type: DO_JOIN_OTHER_DOMAIN_FAIL,
    })
    toast.show({
      title: 'Warning',
      description: 'Failed to join other domain!',
    })
    return Promise.reject(err)
  })
}

// approve or reject domain request
export const doApproveDomainRequest = ({ userRoleId, roleId, type, userId }) => (dispatch, getState) => {
  const { auth: { token } } = getState()

  dispatch({
    type: DO_APPROVE_DOMAIN_REQUEST_START
  })

  return callPost(`/api/domain/approveRequestToJoinDomain`, {
    id: userRoleId,
    roleId: roleId,
    type,
    userId
  }, token).then(res => {
    dispatch({
      type: DO_APPROVE_DOMAIN_REQUEST_SUCCESS,
      data: res['data']
    })
  }).catch(() => {
    dispatch({
      type: DO_APPROVE_DOMAIN_REQUEST_FAIL,
    })
    toast.show({
      title: 'Warning',
      description: `Failed to ${type} domain request!`,
    })
  })
}

export const doGetDomainRequestorsByDomain = ({ domainId }) => (dispatch, getState) => {
  const { auth: { token } } = getState()

  dispatch({
    type: DO_GET_DOMAIN_REQUESTORS_START
  })

  return callGet(`/api/domain/getDomainRequestorsByDomain`, token, {
    domainId: domainId,
  }).then(res => {
    dispatch({
      type: DO_GET_DOMAIN_REQUESTORS_SUCCESS,
      data: res['data']
    })
  }).catch(err => {
    dispatch({
      type: DO_GET_DOMAIN_REQUESTORS_FAIL,
    })
    toast.show({
      title: 'Warning',
      description: 'Failed to get domain requestors!',
    })
  })
}

export const doGetDomainsByUserId = () => (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user

  dispatch({
    type: DO_GET_DOMAINS_BY_USER_ID_START
  })

  return callGet(`/api/domain/getDomainsByUserId`, token, {
    userId: id,
  }).then(res => {
    dispatch({
      type: DO_GET_DOMAINS_BY_USER_ID_SUCCESS,
      data: res['data']
    })
  }).catch(err => {
    dispatch({
      type: DO_GET_DOMAINS_BY_USER_ID_FAIL,
    })
    toast.show({
      title: 'Warning',
      description: 'Failed to get your domains!',
    })
  })
}

export const doGetOtherDomainsByUserId = () => (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user

  dispatch({
    type: DO_GET_OTHER_DOMAINS_BY_USER_ID_START
  })

  return callGet(`/api/domain/getOtherDomainsByUserId`, token, {
    userId: id,
  }).then(res => {
    dispatch({
      type: DO_GET_OTHER_DOMAINS_BY_USER_ID_SUCCESS,
      data: res['data']
    })
  }).catch(err => {
    dispatch({
      type: DO_GET_OTHER_DOMAINS_BY_USER_ID_FAIL,
    })
    toast.show({
      title: 'Warning',
      description: 'Failed to get your domains!',
    })
  })
}

// get other's domain with same name
export const doGetSameDomainWithName = ({ domainName }) => (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user

  return callGet('/api/domain/getSameDomainWithName', token, {
    domainName: domainName,
    userId: id,
  }).then(res => {
    return res['data']
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const doStartUserDomain = ({ domainId }) => (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user

  dispatch({
    type: DO_START_USER_DOMAIN_START
  })

  return callPost(`/api/domain/startUserDomain`, {
    domainId,
    userId: id,
  }, token).then(res => {
    dispatch({
      type: DO_START_USER_DOMAIN_SUCCESS,
      data: res['data']
    })
    dispatch(doLoggedInWithDomain())
    return res['data']
  }).catch(() => {
    dispatch({
      type: DO_START_USER_DOMAIN_FAIL,
    })
  })
}

export const doRemoveDomainInfo = () => (dispatch) => {
  dispatch({
    type: DO_REMOVE_DOMAIN_INFO,
  })
}

export const doSetDomainInfoManually = ({ currentDomain, subdomain }) => (dispatch) => {
  dispatch({
    type: DO_SET_DOMAIN_INFO_MANUALLY,
    data: {
      currentDomain: {
        ...currentDomain?.domain,
        roleName: currentDomain?.userRole?.role?.name,
        userRoleId: currentDomain?.userRole?.id,
        isOwner: currentDomain?.userRole?.isOwner,
      },
      subdomain: subdomain,
    }
  })
}

export const doInviteUserToDomain = ({ domainId, userEmail, roleId, firstName, lastName }) => (dispatch, getState) => {
  const { auth: { token } } = getState()

  dispatch({
    type: DO_INVITE_USER_TO_DOMAIN_START,
  })

  return callPost(`/api/domain/inviteUserToDomain`, {
    domainId,
    userEmail,
    roleId,
    firstName,
    lastName
  }, token).then(res => {
    dispatch({
      type: DO_INVITE_USER_TO_DOMAIN_SUCCESS,
      data: res['data']
    })
    toast.show({
      title: 'Success',
      description: 'Sent invitation successfully!',
    })
  }).catch((err) => {
    dispatch({
      type: DO_INVITE_USER_TO_DOMAIN_FAIL,
    })
    toast.show({
      title: 'Warning',
      description: 'Failed to send invitation!',
    })
    return Promise.reject(err)
  })
}

export const verifyInvitation = (verificationString, email) => (dispatch) => {
  return callGet(`/api/domain/verify/${verificationString}/${email}`).then((res) => {
    toast.show({
      title: 'Success',
      description: res.data.message || 'Domain invitation is activated successfully.',
    })
    return Promise.resolve(res.data.userData)
  }).catch((error) => {
    toast.show({
      title: 'Warning',
      description: 'Try again',
    })
    return Promise.reject('Can not approve domain invitation.')
  })
}

export const doGetJoinedDomainsByUserId = () => (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user

  dispatch({
    type: DO_GET_JOINED_DOMAINS_BY_USER_ID_START,
  })

  return callGet(`/api/domain/getJoinedDomainsByUser`, token, {
    userId: id,
  }).then(res => {
    dispatch({
      type: DO_GET_JOINED_DOMAINS_BY_USER_ID_SUCCESS,
      data: res['data']
    })
  }).catch(err => {
    dispatch({
      type: DO_GET_JOINED_DOMAINS_BY_USER_ID_FAIL,
    })
    toast.show({
      title: 'Warning',
      description: 'Failed to get joined domains!',
    })
  })
}

// accept domain invite request
export const acceptDomainInvitation = ({ domainId }) => (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user

  return callPost(`/api/domain/acceptDomainInvitation`, {
    domainId: domainId,
    userId: id,
  }, token).then((res) => {
    toast.show({
      title: 'Success',
      description: res.data.message || 'Domain invitation is accepted successfully.',
    })
  }).catch(() => {
    toast.show({
      title: 'Warning',
      description: 'Failed to accept domain request!',
    })
  })
}

// reject domain invite request
export const rejectDomainInvitation = ({ domainId }) => (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user

  return callPost(`/api/domain/rejectDomainInvitation`, {
    domainId: domainId,
    userId: id,
  }, token).then((res) => {
    toast.show({
      title: 'Success',
      description: res.data.message || 'Domain invitation is rejected successfully.',
    })
    dispatch(doGetJoinedDomainsByUserId())
  }).catch(() => {
    toast.show({
      title: 'Warning',
      description: 'Failed to reject domain request!',
    })
  })
}

export const doConfirmCredentials = ({ email, firstname, lastname, password }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/domain/confirmCredentials`, {
    email,
    firstname,
    lastname,
    password
  }, token).then((res) => {
    toast.show({
      title: 'Success',
      description: res.data.message,
    })
    return true
  }).catch(() => {
    toast.show({
      title: 'Warning',
      description: 'Failed to confirm user credentials!',
    })
    return Promise.reject('Can not confirm credentials.')
  })
}